'use client'

// "trust fence." -- the website's logo (public/logo.png, the same file as
// fraud-mono-repo/trustfence-website/public/logo), the name, and a period
// in the primary colour (the design system's .brand). `glyphOnly` is the
// collapsed rail.
export function Wordmark({ glyphOnly = false, className = '' }: { glyphOnly?: boolean; className?: string }) {
  return (
    <a href="/" className={`flex items-center justify-center gap-2.5 text-foreground no-underline ${className}`} aria-label="Trust Fence">
      <img src="/logo.png" alt="" className={`shrink-0 object-contain ${glyphOnly ? 'h-10 w-10' : 'h-16 w-16'}`} />
      {!glyphOnly && (
        <span className="text-[22px] font-bold leading-none tracking-[-0.01em]">
          trust fence<span className="text-brand-magenta">.</span>
        </span>
      )}
    </a>
  )
}
